import { APP_PREFIX_PATH } from "configs/AppConfig";
import {
  ContactsOutlined,
  FunnelPlotOutlined,
  CalendarOutlined,
  SettingOutlined,
  MailOutlined,
  CommentOutlined,
  UsergroupAddOutlined,
  DashboardOutlined,
  TrophyOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import translations from "./translations";
import AppLocale from "./../lang/index";

const chosenLang = AppLocale.en.locale;

const dashBoardNavTree = [
  {
    key: "dashboard",
    path: `${APP_PREFIX_PATH}/dashboard`,
    title: translations[13][chosenLang],
    breadcrumb: false,
    submenu: [],
    icon: DashboardOutlined,
  },
  {
    key: "contacts",
    path: `${APP_PREFIX_PATH}/contacts`,
    title: translations[0][chosenLang],
    breadcrumb: false,
    submenu: [],
    icon: ContactsOutlined,
  },
  {
    key: "conversations",
    title: translations[8][chosenLang],
    breadcrumb: false,
    icon: CommentOutlined,
    submenu: [
      {
        key: "inbox",
        path: `${APP_PREFIX_PATH}/conversations`,
        title: translations[39][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "call-report",
        path: `${APP_PREFIX_PATH}/conversations/call-report`,
        title: translations[40][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
  {
    key: "funnels",
    path: `${APP_PREFIX_PATH}/funnels`,
    title: translations[1][chosenLang],
    breadcrumb: false,
    submenu: [],
    icon: FunnelPlotOutlined,
  },
  {
    key: "marketing",
    title: translations[2][chosenLang],
    breadcrumb: false,
    icon: MailOutlined,
    submenu: [
      {
        key: "campaigns",
        path: `${APP_PREFIX_PATH}/campaigns`,
        title: translations[3][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "embed-code",
        path: `${APP_PREFIX_PATH}/embed-code`,
        title: translations[16][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "email-builder",
        path: `${APP_PREFIX_PATH}/email-builder/templates`,
        title: translations[4][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "sms-builder",
        path: `${APP_PREFIX_PATH}/sms-builder`,
        title: translations[5][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "forms",
        path: `${APP_PREFIX_PATH}/forms`,
        title: translations[10][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "ads",
        path: `${APP_PREFIX_PATH}/ads`,
        title: translations[41][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "chat-widget",
        path: `${APP_PREFIX_PATH}/chat-widget`,
        title: translations[11][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "virtual-consult",
        path: `${APP_PREFIX_PATH}/virtual-consult`,
        title: translations[26][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "specials",
        path: `${APP_PREFIX_PATH}/specials`,
        title: translations[35][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "webhooks",
        path: `${APP_PREFIX_PATH}/webhooks`,
        title: translations[38][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
  {
    key: "my-practice",
    path: `${APP_PREFIX_PATH}/my-practice`,
    title: translations[12][chosenLang],
    breadcrumb: false,
    submenu: [
      {
        key: "practice-info",
        path: `${APP_PREFIX_PATH}/practice-info`,
        title: translations[14][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "employee-calendar",
        path: `${APP_PREFIX_PATH}/employee-calendar`,
        title: translations[27][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "practice-staff",
        path: `${APP_PREFIX_PATH}/practice-staff`,
        title: translations[15][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "documents",
        path: `${APP_PREFIX_PATH}/documents`,
        title: translations[20][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "charting",
        path: `${APP_PREFIX_PATH}/charting`,
        title: translations[32][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "questionnaires",
        path: `${APP_PREFIX_PATH}/questionnaires`,
        title: translations[33][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "rooms",
        path: `${APP_PREFIX_PATH}/rooms`,
        title: translations[25][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "memberships",
        path: `${APP_PREFIX_PATH}/memberships`,
        title: translations[29][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "gift-cards",
        path: `${APP_PREFIX_PATH}/gift-cards`,
        title: translations[36][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "packages",
        path: `${APP_PREFIX_PATH}/packages`,
        title: translations[37][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
    ],
    icon: UsergroupAddOutlined,
  },
  {
    key: "scheduler",
    path: `${APP_PREFIX_PATH}/scheduler`,
    title: translations[6][chosenLang],
    breadcrumb: false,
    submenu: [],
    icon: CalendarOutlined,
  },
  {
    key: "reporting",
    path: `${APP_PREFIX_PATH}/reporting`,
    title: translations[21][chosenLang],
    breadcrumb: false,
    submenu: [
      {
        key: "dashboard-summary",
        path: `${APP_PREFIX_PATH}/dashboard-summary`,
        title: translations[30][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "transactions",
        path: `${APP_PREFIX_PATH}/transactions`,
        title: translations[22][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "transaction-reporting",
        path: `${APP_PREFIX_PATH}/transaction-reporting`,
        title: translations[34][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "treatments",
        path: `${APP_PREFIX_PATH}/treatments`,
        title: translations[28][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "sub-marketing",
        path: `${APP_PREFIX_PATH}/marketing`,
        title: translations[23][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "services",
        path: `${APP_PREFIX_PATH}/services`,
        title: translations[31][chosenLang],
        breadcrumb: false,
        submenu: [],
      },
    ],
    icon: BarChartOutlined,
  },
  {
    key: "loyalty-program",
    path: `${APP_PREFIX_PATH}/awards`,
    title: translations[17][chosenLang],
    breadcrumb: false,
    submenu: [],
    icon: TrophyOutlined,
  },
  {
    key: "settings",
    path: `${APP_PREFIX_PATH}/settings`,
    title: translations[7][chosenLang],
    breadcrumb: false,
    submenu: [],
    icon: SettingOutlined,
  },
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
